import { DataHeader, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutState extends Layout {
    dataheaderState: DataHeader;
    sourceStates: DataSource;
    textboxCountryId: Textbox;
    textboxId: Textbox;
    textboxName: Textbox;
}
